// test1177
(1177 && 0);
